import { Box, Typography } from "@mui/material";
import { describePermission } from "encamp-shared/src/constants/permissionDescriptions";

type PermissionCheckboxLabelProps = {
  permission: string;
};

/**
 * Enum name plus the plain-English sentence, shared by the role editor and
 * the emulate-permissions dialog.
 */
export function PermissionCheckboxLabel({ permission }: PermissionCheckboxLabelProps) {
  const description = describePermission(permission);
  return (
    <Box sx={{ mt: 0.75, ml: 0.5 }}>
      <Typography component="span" variant="body1">
        {permission}
      </Typography>
      {description ? (
        <Typography variant="caption" display="block" color="text.secondary">
          {description}
        </Typography>
      ) : null}
    </Box>
  );
}
